import type { RouteEntry } from '../types';

// ═══════════════════════════════════════════════════════════════════════════
// POLICY DATA
// ═══════════════════════════════════════════════════════════════════════════
export const POLICY_DATA_ROUTES: RouteEntry[] = [
  {
    path: 'policy-data',
    component: 'PolicyDataDashboardPage',
    label: 'Dashboard',
    allowedRoles: [], // no ProtectedRoute wrapper
    functionality: 'policy_data',
    navSection: 'Overview',
    navIcon: 'Dashboard',
    // MISMATCH: route has no role guard
  },
  {
    path: 'policy-data/upload',
    component: 'PolicyDataUploadPage',
    label: 'Policy Data Input',
    allowedRoles: ['super_admin', 'admin', 'company_user', 'consultant_user'],
    functionality: 'policy_data',
    navSection: 'Data Entry',
    navIcon: 'CloudUpload',
    navRoles: ['super_admin', 'admin', 'company_user', 'consultant_user'],
  },
  {
    path: 'policy-data/claims',
    component: 'ClaimsDataEntryPage',
    label: 'Claims Data Entry',
    allowedRoles: ['super_admin', 'admin', 'company_user', 'consultant_user'],
    functionality: 'policy_data',
    navSection: 'Data Entry',
    navIcon: 'Receipt',
    navRoles: ['super_admin', 'admin', 'company_user', 'consultant_user'],
  },
  {
    path: 'policy-data/endorsements',
    component: 'EndorsementsPage',
    label: 'Endorsements',
    allowedRoles: ['super_admin', 'admin', 'company_user', 'consultant_user', 'auditor', 'executive'],
    functionality: 'policy_data',
    navSection: 'Data Entry',
    navIcon: 'FactCheck',
    navRoles: ['super_admin', 'admin', 'company_user', 'consultant_user', 'auditor', 'executive'],
  },
  {
    path: 'policy-data/members',
    component: 'MemberRegistryPage',
    label: 'Member Registry',
    allowedRoles: ['super_admin', 'admin', 'company_user', 'consultant_user', 'auditor', 'executive'],
    functionality: 'policy_data',
    navSection: 'Reports',
    navIcon: 'People',
    // MISMATCH: nav has no roles (all) but route restricts to 6 roles (no regulator)
  },
  {
    path: 'policy-data/movements',
    component: 'MembershipMovementsPage',
    label: 'Membership Movements',
    allowedRoles: ['super_admin', 'admin', 'company_user', 'consultant_user', 'auditor', 'executive'],
    functionality: 'policy_data',
    navSection: 'Reports',
    navIcon: 'CompareArrows',
    // MISMATCH: nav has no roles (all) but route restricts to 6 roles (no regulator)
  },
  {
    path: 'policy-data/cohort-categories',
    component: 'CohortCategoriesPage',
    label: 'Cohort Categories',
    allowedRoles: ['super_admin', 'admin', 'company_user', 'consultant_user', 'auditor', 'executive'],
    functionality: 'policy_data',
    navSection: 'Reports',
    navIcon: 'Category',
    // MISMATCH: nav has no roles (all) but route restricts to 6 roles (no regulator)
  },
  {
    path: 'policy-data/cohorts',
    component: 'CohortSummaryPage',
    label: 'Cohort Summary',
    allowedRoles: ['super_admin', 'admin', 'company_user', 'consultant_user', 'auditor', 'executive'],
    functionality: 'policy_data',
    navSection: 'Reports',
    navIcon: 'TableChart',
    // MISMATCH: nav has no roles (all) but route restricts to 6 roles (no regulator)
  },
];
